// extracted by mini-css-extract-plugin
module.exports = {"view":"view--1_kfI","view__title":"view__title--3htUO","view__description":"view__description--1eShp","view__image":"view__image--23Z4A"};